import React, { Component } from 'react';
import './Cover.css';

export default class Cover extends Component {

    render() {

        return (
            <div className="Cover"></div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Cover/Cover.js